import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";


const BuyPage = () => {
    return (
        <div className="buy-page-wrapper d-none d-lg-block" id="buy-page-scroll">
            <div className="content-buy-page xmt-22">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <div className="gallery-product">
                                <div
                                    className="product-gallery-image d-flex justify-content-center align-items-center position-relative">
                                    <div className="price-box position-absolute">
                                        <div className="title-timer-product d-flex">
                                            <div className="text-offer"><span className="txt">پیشنهاد ویژه</span></div>
                                            <div className="number-timer">
                        <span className="timer-interval-box"
                              data-time-offer="november 28, 2021 19:37:25">00:00:00</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="image-zoom">
                                        <div className="swiper swiper-image-buy-page">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp"
                                                            alt="img" className="img-fluid img-zoom-event"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/26/x1IVuf3xK26rbAt0XXic5AaDO36T1SMPfvvIMRTL_medium.webp"
                                                            alt="img" className="img-fluid img-zoom-event"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/27/WbfVYhaM6JUtvLlQIG3LcPgnNBAdkoR3YGUpHrQk_medium.webp"
                                                            alt="img" className="img-fluid img-zoom-event"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp"
                                                            alt="img" className="img-fluid img-zoom-event"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <iframe className="iframe-video"
                                                                src="https://www.aparat.com/video/video/embed/videohash/PRWm6/vt/frame"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="gallery-swiper-wrapper xp-4 position-absolute">
                                        <div className="link-products-gallery-prev-buy-page position-absolute">
                                            <IconName name="chevron_left" className="icon"/>
                                        </div>
                                        <div className="swiper gallery-swiper-buy-page">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp"
                                                            alt="img1"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/26/x1IVuf3xK26rbAt0XXic5AaDO36T1SMPfvvIMRTL_medium.webp"
                                                            alt="img1"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/27/WbfVYhaM6JUtvLlQIG3LcPgnNBAdkoR3YGUpHrQk_medium.webp"
                                                            alt="img1"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img
                                                            src="https://saymandigital.com/storage/uploads/2021/10/26/HS5ficL79EKHr8tpQezFeg5POjxinQwLLA95M3Li_medium.webp"
                                                            alt="img1"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box video-play">
                                                        <img
                                                            src="./assets/sample-image/f6ca859b10af45a6074568ec043ddb20.png"
                                                            alt="img1"/>
                                                        <IconName name="play" className="icon position-absolute"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img src="./assets/sample-image/image 31.png" alt="img1"/>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="img-box">
                                                        <img src="./assets/sample-image/image 31.png" alt="img1"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="link-products-gallery-next-buy-page position-absolute">
                                            <IconName name="chevron_left" className="icon"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="buy-step">
                                <div className="color-product" id="color-buy-page-scroll">
                                    <div className="title-selection"><span className="title">رنگ مورد نظر؟</span></div>
                                    <div className="list-selection">
                                        <ul className="list-unstyled">
                                            <li className="d-flex justify-content-between align-items-center active selection-color">
                                                <div className="selection-name"><span
                                                    className="black color-box"></span>مشکی
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-color">
                                                <div className="selection-name"><span
                                                    className="white color-box"></span>سفید
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-color">
                                                <div className="selection-name"><span
                                                    className="green color-box"></span>فیروزه ای
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-color">
                                                <div className="selection-name"><span className="blue color-box"></span>آبی
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-color">
                                                <div className="selection-name"><span className="red color-box"></span>قرمز
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="ram-product" id="ram-product-info-scroll">
                                    <div className="title-selection"><span className="title">مقدار حافظه‌ی داخلی؟</span>
                                    </div>
                                    <div className="list-selection">
                                        <ul className="list-unstyled persian-number">
                                            <li className="d-flex justify-content-between align-items-center active selection-ram">
                                                <div className="selection-name">۶۴ گیگ
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-ram">
                                                <div className="selection-name">۱۲۸ گیگ
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">۶،۸۳۹،۰۰۰ ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-ram">
                                                <div className="selection-name">۲۵۶ گیگ
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">۵،۴۸۹،۰۰۰ ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-ram">
                                                <div className="selection-name">۵۱۲ گیگ
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="warranty-product" id="warranty-scroll-buy-page">
                                    <div className="title-selection"><span className="title">خدمات پس از فروش؟</span>
                                        <p className="text-warranty">گارانتی 7 روز بازگشت برای کالاهای بدون گارانتی
                                            شرکتی بوده و خدمات کالاهای گارانتی دار، تماما به عهده شرکت گارانتی کننده می
                                            باشد.</p>
                                    </div>
                                    <div className="list-selection">
                                        <ul className="list-unstyled persian-color">
                                            <li className="d-flex justify-content-between align-items-center active selection-warranty">
                                                <div className="selection-name"><IconName name="verified_user"
                                                                                          className="icon"/>گارانتی ۱۸
                                                    ماهه‌ی سایمان
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">5,489,000 ت</span>
                                                </div>
                                            </li>
                                            <li className="d-flex justify-content-between align-items-center selection-warranty">
                                                <div className="selection-name"><IconName name="noshield"
                                                                                          className="icon"/>گارانتی ۱۸
                                                    ماهه‌ی سایمان
                                                </div>
                                                <div className="price"><span
                                                    className="persian-number">۶،۸۳۹،۰۰۰ ت</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="accessories-product" id='accessories-scroll-buy-page'>
                                    <div className="title-accessories"><span
                                        className="title">لوازم جانبی این محصول</span></div>

                                    <div className="accessories-card" id="box1">
                                        <div className="row">
                                            <div className="col-6 xmt-4">
                                                <div className="product position-relative">
                                                    <div className="product-price">
                                                        <span className="total-price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                        <span className="discount persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                    </div>
                                                    <div
                                                        className="img  d-flex justify-content-center align-items-center xmb-3">
                                                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"
                                                             className="img-fluid"/>
                                                    </div>
                                                    <div className="text-center">
                                                        <h3 className="title">کاور سیلیکنی مشکی</h3>
                                                    </div>
                                                    <div
                                                        className="color-range">
                                                        <div
                                                            className="color-box accessories-color-box black active"><span
                                                            className="color"></span> مشکی
                                                        </div>
                                                        <div className="color-box accessories-color-box white"><span
                                                            className="color"></span> سفید
                                                        </div>
                                                        <div className="color-box accessories-color-box red"><span
                                                            className="color"></span> قرمز
                                                        </div>
                                                        <div className="color-box accessories-color-box blue"><span
                                                            className="color"></span> آبی
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="add-cart">
                                                    <IconName name="add" className="icon"/>
                                                    <a href="#">افزودن به سبد خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-6 xmt-4">
                                                <div className="product position-relative">
                                                    <div className="product-price">
                                                        <span className="total-price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                        <span className="discount persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                    </div>
                                                    <div
                                                        className="img  d-flex justify-content-center align-items-center xmb-3">
                                                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"
                                                             className="img-fluid"/>
                                                    </div>
                                                    <div className="text-center">
                                                        <h3 className="title">کاور سیلیکنی مشکی</h3>
                                                    </div>
                                                    <div
                                                        className="color-range">
                                                        <div
                                                            className="color-box accessories-color-box active black"><span
                                                            className="color"></span> مشکی
                                                        </div>
                                                        <div className="color-box accessories-color-box white"><span
                                                            className="color"></span> سفید
                                                        </div>
                                                        <div className="color-box accessories-color-box red"><span
                                                            className="color"></span> قرمز
                                                        </div>
                                                        <div className="color-box accessories-color-box blue"><span
                                                            className="color"></span> آبی
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="add-cart">
                                                    <IconName name="add" className="icon"/>
                                                    <a href="#">افزودن به سبد خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-6 xmt-8">
                                                <div className="product position-relative">
                                                    <div className="product-price">
                                                        <span className="total-price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                        <span className="discount persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                    </div>
                                                    <div
                                                        className="img  d-flex justify-content-center align-items-center xmb-3">
                                                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"
                                                             className="img-fluid"/>
                                                    </div>
                                                    <div className="text-center">
                                                        <h3 className="title">کاور سیلیکنی مشکی</h3>
                                                    </div>
                                                    <div
                                                        className="color-range">
                                                        <div
                                                            className="color-box accessories-color-box active black"><span
                                                            className="color"></span> مشکی
                                                        </div>
                                                        <div className="color-box accessories-color-box white"><span
                                                            className="color"></span> سفید
                                                        </div>
                                                        <div className="color-box accessories-color-box red"><span
                                                            className="color"></span> قرمز
                                                        </div>
                                                        <div className="color-box accessories-color-box blue"><span
                                                            className="color"></span> آبی
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="add-cart">
                                                    <IconName name="add" className="icon"/>
                                                    <a href="#">افزودن به سبد خرید</a>
                                                </div>
                                            </div>
                                            <div className="col-6 xmt-8">
                                                <div className="product position-relative">
                                                    <div className="product-price">
                                                        <span className="total-price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                        <span className="discount persian-number">۲،۷۶۰،۰۰۰ ت</span>
                                                    </div>
                                                    <div
                                                        className="img  d-flex justify-content-center align-items-center xmb-3">
                                                        <img src="./assets/sample-image/1420-w320h320.png" alt="img"
                                                             className="img-fluid"/>
                                                    </div>
                                                    <div className="text-center">
                                                        <h3 className="title">کاور سیلیکنی مشکی</h3>
                                                    </div>
                                                    <div
                                                        className="color-range">
                                                        <div
                                                            className="color-box accessories-color-box active black"><span
                                                            className="color"></span> مشکی
                                                        </div>
                                                        <div className="color-box accessories-color-box white"><span
                                                            className="color"></span> سفید
                                                        </div>
                                                        <div className="color-box accessories-color-box red"><span
                                                            className="color"></span> قرمز
                                                        </div>
                                                        <div className="color-box accessories-color-box blue"><span
                                                            className="color"></span> آبی
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="add-cart">
                                                    <IconName name="add" className="icon"/>
                                                    <a href="#">افزودن به سبد خرید</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="up-scroll xmt-10" id="up-scroll-page">
                                        <a href="#">بازگشت به بالا <IconName
                                            name="expand_less" className="icon"/></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="buy-step-fixed position-fixed">
                    <div className="container d-flex justify-content-between align-items-center">
                        <div className="buttons d-flex align-items-center">
                            <div className="button-prev">
                                <a href="#" id="prev-button-scroll">
                                    <IconName name="chevron_left" className="icon"/>
                                    <span className="text">قبلی</span>
                                </a>
                            </div>
                            <div className="button-next">
                                <a href="#ram-product-info-scroll" id="button-scroll-buy-page">
                                    <span className="text">بعدی</span>
                                    <IconName name="chevron_left" className="icon"/>
                                </a>
                            </div>
                        </div>
                        <div className="progress-buy" id="step-progress-buy-page">
                            <span className="item active"></span>
                            <span className="item"></span>
                            <span className="item"></span>
                            <span className="item"></span>
                        </div>
                        <div className="price">
                            <IconName name="cart" className="icon"/>
                            <span className="persian-number">۵،۴۸۹،۰۰۰ ت</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BuyPage;
